import React, { useState } from 'react';
import { DERSLER } from '../../lib/dersler.js';
import { esitKova, agirlikliKova, zorlukGecerliMi, KOVA_RENK, secimSinifi, SECILI_ISARET, konuAdetToplami } from './yardimcilar';
import KonuZorlukListesi from './KonuZorlukListesi';
// Faz C (2026-09-03): Basim.js'ten satır aralığıyla BİREBİR taşındı — davranış değişmedi.

// ═══════════════════════════════════════════════════════════════════════════
// DERS BAZLI ZORLUK (2026-08-20, öğretmen isteği: "denemeler oluşturulurken
// kolay, orta zor gibi ders ders seviyeler belirlenebilsin")
//
// Ders başına ÜÇ SAYI: tek seviye isteği bunun özel halidir (30/0/0 = tümü
// zor), tersi değil. Toplam ders kotasına eşit olmalı — eşit değilse satır
// kırmızı ve basım kilitli (backend de 400'ler; panel isteği hiç göndermez).
// ═══════════════════════════════════════════════════════════════════════════
// Faz C (2026-09-03): konu bazlı isteğe bağlı seviye — `konuZorluk` {ders:{konu:kova}},
// ders satırı açıkken "konu bazlı ▸" ile açılır (KonuZorlukListesi). Ders kotasını
// DEĞİŞTİRMEZ; o konunun soruları seçilen kovadan gelir (backend Faz A).
// Sade akış (2026-09-03, kullanıcı): ön ayar düğmeleri seçili durumunu GÖSTERİR —
// aktif ön ayar `dersZorluk`tan türetilir (boş = Dengeli), özel değerlerde hiçbiri.
const ON_AYARLAR = [
  { id: 'dengeli', l: 'Dengeli', a: null, t: 'Her derste kolay/orta/zor eşit (varsayılan)' },
  { id: 'kolay', l: 'Kolay ağırlıklı', a: { kolay: 3, orta: 2, zor: 1 }, t: '%50 kolay · %33 orta · %17 zor' },
  { id: 'zor', l: 'Zor ağırlıklı', a: { kolay: 1, orta: 2, zor: 3 }, t: '%17 kolay · %33 orta · %50 zor' },
  { id: 'tumu_zor', l: 'Tümü zor', a: { kolay: 0, orta: 0, zor: 1 }, t: 'Her ders yalnız zor kovadan (havuz yetmezse ortanın üstünden dolar)' },
];
const ayniKova = (a, b) => !!a && !!b && a.kolay === b.kolay && a.orta === b.orta && a.zor === b.zor;

export function aktifOnAyar(dersZorluk, tumDersler) {
  if (!tumDersler.length) return Object.keys(dersZorluk || {}).length === 0 ? 'dengeli' : null;
  for (const p of ON_AYARLAR) {
    const uyuyor = tumDersler.every(d => {
      const mevcut = (dersZorluk && dersZorluk[d.ders]) || esitKova(d.kota);
      const beklenen = p.a ? agirlikliKova(d.kota, p.a) : esitKova(d.kota);
      return ayniKova(mevcut, beklenen);
    });
    if (uyuyor) return p.id;
  }
  return null;
}

function ZorlukDagilimPaneli({ fizibilite, dersZorluk, onDegis, konuZorluk = {}, onKonuZorlukDegis, apiUrl, mufredat }) {
  const [acikDers, setAcikDers] = useState(null);
  const [konuAcik, setKonuAcik] = useState(false);
  const tumDersler = (fizibilite.testler || []).flatMap(t => t.dersler);
  const aktif = aktifOnAyar(dersZorluk, tumDersler);

  const presetUygula = (agirlik) => {
    const yeni = {};
    for (const d of tumDersler) {
      yeni[d.ders] = agirlik ? agirlikliKova(d.kota, agirlik) : esitKova(d.kota);
    }
    onDegis(yeni);
  };

  const dersDegis = (ders, kova, deger, kota) => {
    const mevcut = dersZorluk[ders] || esitKova(kota);
    const v = Math.max(0, Math.min(kota, parseInt(deger, 10) || 0));
    onDegis({ ...dersZorluk, [ders]: { ...mevcut, [kova]: v } });
  };

  // "Kalanı dağıt": değiştirilen kovayı sabit tutup diğer ikisini kotaya
  // tamamlar — öğretmen üç kutuyu elle denkleştirmek zorunda kalmasın.
  const dengele = (ders, kota) => {
    const u = dersZorluk[ders] || esitKova(kota);
    const toplam = u.kolay + u.orta + u.zor;
    const fark = kota - toplam;
    if (fark === 0) return;
    const yeni = { ...u, orta: Math.max(0, u.orta + fark) };
    const t2 = yeni.kolay + yeni.orta + yeni.zor;
    if (t2 !== kota) yeni.kolay = Math.max(0, yeni.kolay + (kota - t2));
    onDegis({ ...dersZorluk, [ders]: yeni });
  };

  return (
    <div className="space-y-1">
      <div className="flex flex-wrap items-center gap-1.5 mb-1">
        <span className="text-[10px] font-bold uppercase opacity-70">Zorluk dağılımı:</span>
        {ON_AYARLAR.map(p => (
          <button key={p.id} type="button" onClick={() => presetUygula(p.a)} title={p.t}
            aria-pressed={aktif === p.id} className={secimSinifi(aktif === p.id)}>
            {aktif === p.id ? SECILI_ISARET : ''}{p.l}
          </button>
        ))}
        {aktif === null && (
          <span className="px-1.5 py-0.5 rounded bg-amber-100 text-amber-900 text-[10px] font-semibold"
            title="Ders değerleri elle değiştirildi; hiçbir ön ayara denk düşmüyor">özel dağılım</span>
        )}
        {Object.keys(dersZorluk).length > 0 && (
          <button onClick={() => onDegis({})} title="Varsayılana dön (eşit dağılım)"
            className="px-1.5 py-0.5 rounded bg-white/60 text-[10px] hover:bg-white">✕ sıfırla</button>
        )}
      </div>
      {(fizibilite.testler || []).map(t => (
        <div key={t.kod} className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <span className="font-semibold min-w-[110px]">{t.ad}:</span>
          {t.dersler.map(d => {
            const ozel = dersZorluk[d.ders];
            const kova = ozel || d.kova_kota || esitKova(d.kota);
            const toplam = kova.kolay + kova.orta + kova.zor;
            const dengesiz = toplam !== d.kota;
            const acik = acikDers === d.ders;
            // Slot etiketi (slot-ders 2026-09-03): fizibilite `ad` (Tarih-1) > DERSLER etiketi.
            const ad = d.ad || (DERSLER.find(x => x.value === d.ders)?.label || d.ders).replace(/^(TYT|AYT)\s+/i, '');
            const konuSayisi = Object.keys((konuZorluk && konuZorluk[d.ders]) || {}).length;
            const sabitAdet = konuAdetToplami((konuZorluk && konuZorluk[d.ders]) || {});
            return (
              <span key={d.ders} className="inline-flex flex-col">
                <button
                  onClick={() => setAcikDers(acik ? null : d.ders)}
                  title={`havuz — kolay ${d.havuz.kolay} / orta ${d.havuz.orta} / zor ${d.havuz.zor}`
                    + (d.uyari ? ` — ${d.uyari}` : '') + '\nTıkla: zorluk dağılımını ayarla'}
                  className={`px-1.5 py-0.5 rounded text-left ${dengesiz
                    ? 'bg-red-200 text-red-900 font-bold ring-1 ring-red-500'
                    : !d.uygun ? 'bg-red-200 text-red-900 font-bold'
                      : d.uyari ? 'bg-amber-100 text-amber-900' : 'bg-white/70'} ${acik ? 'ring-2 ring-blue-400' : ''} hover:ring-1 hover:ring-current/30`}>
                  {ad} <strong>{d.havuz.toplam}</strong>/{d.kota}
                  {ozel && <span className="ml-1 text-[9px] opacity-80">
                    ({kova.kolay}/{kova.orta}/{kova.zor})</span>}
                  {dengesiz ? ' ✕' : d.uyari && !d.uygun ? ' ⛔' : d.uyari ? ' ⚠' : ''}
                  {konuSayisi > 0 && <span className="ml-1 text-[9px] px-1 rounded bg-indigo-100 text-indigo-800" title={`Konu bazlı ayar verilmiş konu sayısı${sabitAdet > 0 ? ` — ${sabitAdet} soru konu adediyle sabit` : ''}`}>· {konuSayisi} konu{sabitAdet > 0 ? ` · ${sabitAdet} sabit` : ''}</span>}
                </button>
                {acik && (
                  <span className="mt-1 flex items-center gap-1 bg-white rounded border border-gray-300 px-1.5 py-1 shadow-sm">
                    {['kolay', 'orta', 'zor'].map(k => (
                      <span key={k} className="flex items-center gap-0.5">
                        <span className={`text-[9px] px-1 rounded ${KOVA_RENK[k]}`}>{k[0].toUpperCase()}</span>
                        <input type="number" min={0} max={d.kota} value={kova[k]}
                          onChange={e => dersDegis(d.ders, k, e.target.value, d.kota)}
                          className="w-10 px-1 py-0.5 border border-gray-300 rounded text-[10px] text-center" />
                      </span>
                    ))}
                    <span className={`text-[9px] ${dengesiz ? 'text-red-600 font-bold' : 'text-gray-500'}`}>
                      = {toplam}/{d.kota}
                    </span>
                    {dengesiz && (
                      <button onClick={() => dengele(d.ders, d.kota)}
                        className="text-[9px] px-1 py-0.5 rounded bg-blue-100 text-blue-700 font-semibold hover:bg-blue-200">
                        kalanı dağıt
                      </button>
                    )}
                    {onKonuZorlukDegis && (
                      <button type="button" onClick={() => setKonuAcik(v => !v)}
                        title="Bu dersin belirli konularına ayrı seviye ver (isteğe bağlı)"
                        className="text-[9px] px-1 py-0.5 rounded bg-indigo-100 text-indigo-700 font-semibold hover:bg-indigo-200">
                        konu bazlı {konuAcik ? '▾' : '▸'}
                      </button>
                    )}
                  </span>
                )}
                {acik && konuAcik && onKonuZorlukDegis && (
                  <KonuZorlukListesi apiUrl={apiUrl} slot={d.ders} ders={d.havuz_ders || d.ders}
                    kazanimOnek={d.kazanim_onek || []} mufredat={mufredat} kota={d.kota}
                    deger={(konuZorluk && konuZorluk[d.ders]) || {}}
                    fizibiliteKonu={d.konu_override || []}
                    onDegis={(yeni) => {
                      const kopya = { ...(konuZorluk || {}) };
                      if (Object.keys(yeni).length === 0) delete kopya[d.ders]; else kopya[d.ders] = yeni;
                      onKonuZorlukDegis(kopya);
                    }} />
                )}
              </span>
            );
          })}
        </div>
      ))}
      {Object.keys(dersZorluk).length > 0 && !zorlukGecerliMi(dersZorluk, fizibilite) && (
        <div className="text-[10px] text-red-700 font-semibold pt-0.5">
          ⛔ Bir veya birden fazla dersin kolay+orta+zor toplamı ders kotasına eşit değil —
          düzeltilene kadar basım kapalı.
        </div>
      )}
    </div>
  );
}

export default ZorlukDagilimPaneli;
